import { Analytics } from 'analytics';
import { plugins } from './plugins';
var ANALYTICS_UNLOAD_EVENT = 'unload';
var analytics = Analytics({
  app: '@miro-site/shared/user-tracking',
  plugins: plugins
});
var track = analytics.track,
    identify = analytics.identify,
    page = analytics.page,
    reset = analytics.reset,
    on = analytics.on,
    once = analytics.once,
    storage = analytics.storage; // The dispatch property is not exposed in the types and we need to dispatch event so plugins might properly clean up

export { track, identify, page, reset, on, once, storage };
export var unloadAnalytics = function unloadAnalytics() {
  return analytics['dispatch'](ANALYTICS_UNLOAD_EVENT);
};
export var onAnalyticsUnload = function onAnalyticsUnload(callback) {
  return on(ANALYTICS_UNLOAD_EVENT, callback);
};